@if (!isLoading) {
  <div class="tw-flex tw-flex-col tw-gap-5">
    @if (reports.length === 0) {
      <p class="tw-py-5 tw-text-center">{{ 'common.noReport' | translate }}</p>
    }
    @for (report of reports; track report) {
      <section class="tw-border tw-border-divider">
        <!-- For company -->
        <app-accordion
          [headerClass]="'tw-bg-white hover:tw-bg-divider/20 disabled:hover:tw-bg-white tw-rounded-lg tw-text-left'"
          [isDisabled]="report?.sections?.length === 0"
        >
          <div accordion-title>
            <app-thumbnail-group
              [imageUrl]="report.company?.companyLogoUrl"
              [name]="report.company?.brandName"
              [description]="report.company?.name"
            >
            </app-thumbnail-group>
          </div>
          <div class="tw-divide-y tw-divide-divider">
            @if (report.sections?.length > 0) {
              @for (section of report.sections; track section) {
                <div>
                  <!-- For years, or General -->
                  <app-accordion [headerClass]="'tw-text-sm'" [isCollapsed]="true">
                    <div accordion-title>{{ section?.name }}</div>
                    <!-- Table header -->
                    <div class="grid-table__wrapper">
                      <div class="grid-table__head tw-grid tw-grid-cols-4">
                        <div class="tw-col-span-2 max-sm:tw-col-span-3 lg:tw-pr-8">
                          {{ 'company.documentName' | translate }}
                        </div>
                        <div class="max-sm:tw-hidden">{{ 'common.date' | translate }}</div>
                        <div class="tw-text-right">{{ 'common.action' | translate }}</div>
                      </div>
                    </div>
                    <!-- Table body -->
                    @for (document of section?.documents; track document) {
                      <div
                        class="grid-table__body tw-grid tw-grid-cols-4 tw-text-xs hover:tw-bg-divider/20"
                      >
                        <div
                          class="tw-col-span-2 tw-flex tw-flex-wrap tw-justify-between tw-gap-2.5 max-sm:tw-col-span-3 max-sm:tw-items-center max-sm:tw-gap-0.5 lg:tw-pr-8"
                        >
                          <div>
                            <button
                              type="button"
                              class="p-link-secondary tw-px-0"
                              (click)="openUrl(document.url)"
                            >
                              {{ document?.attachmentName }}
                            </button>
                            <div class="tw-text-xxs tw-text-body/80 sm:tw-hidden">
                              {{ document?.createdAt | date: 'd MMM yyyy' }}
                            </div>
                          </div>
                          <!-- Investor only badge -->
                          @if (
                            document?.attachmentType?.audience === AttachmentAudience.InvestorOnly
                          ) {
                            <span
                              class="tw-select-none tw-rounded tw-border tw-border-divider/60 tw-px-1 tw-py-0.5 tw-text-xxs tw-text-body/60"
                              >{{ 'common.investorOnly' | translate }}</span
                            >
                          }
                        </div>
                        <div class="max-sm:tw-hidden">
                          {{ document?.createdAt | date: 'd MMM yyyy' }}
                        </div>
                        <div class="tw-flex tw-items-center tw-justify-end !tw-pr-6">
                          <button
                            type="button"
                            title="Download"
                            class="tw-h-5 tw-w-5 tw-bg-transparent"
                            (click)="openUrl(document.url)"
                          >
                            <span
                              class="pitchin-icon-download tw-inline-block tw-h-5 tw-w-5"
                            ></span>
                          </button>
                        </div>
                      </div>
                    }
                  </app-accordion>
                </div>
              }
            } @else {
              <div
                class="tw-select-none tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-text-body/80"
              >
                {{ 'common.noReport' | translate }}
              </div>
            }
          </div>
        </app-accordion>
      </section>
    }
  </div>
} @else {
  <div class="">
    <app-skeleton [width]="'60%'" [height]="2.5"></app-skeleton>
    <app-skeleton></app-skeleton>
    <app-skeleton></app-skeleton>
    <app-skeleton [width]="'30%'"></app-skeleton>
  </div>
}
